export const SETTINGS_SECTION = {
  GENERAL: "general",
  INTEGRATIONS: "integrations",
  MEETINGS: "meetings",
  CONVERSATIONS: "conversations",
  TENANTS: "tenants",
  CREDITS: "credits",
  USERS: "users",
  GROUPS: "groups",
  BOTS: "bots",
} as const;

export type SettingsSection =
  (typeof SETTINGS_SECTION)[keyof typeof SETTINGS_SECTION];

export const DEFAULT_SETTINGS_SECTION = SETTINGS_SECTION.GENERAL;

const SETTINGS_SECTIONS = new Set<string>(Object.values(SETTINGS_SECTION));

export function isSettingsSection(
  value: string | undefined,
): value is SettingsSection {
  return value !== undefined && SETTINGS_SECTIONS.has(value);
}
